import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "category" }
const _hoisted_2 = { class: "options" }
const _hoisted_3 = { class: "selected" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_TE-font-colorB" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_opozorilo" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_zapora" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_road-work" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_zastoj" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("sidebar_traffic_info.type")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(_toDisplayString(_ctx.$t("sidebar_traffic_info.all")), 1)
      ]),
      _createElementVNode("button", null, [
        _hoisted_5,
        _createTextVNode(_toDisplayString(_ctx.$t("sidebar_traffic_info.extraordinary")), 1)
      ]),
      _createElementVNode("button", null, [
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("sidebar_traffic_info.congestion")), 1)
      ]),
      _createElementVNode("button", null, [
        _hoisted_7,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("sidebar_traffic_info.roadwork")), 1)
      ]),
      _createElementVNode("button", null, [
        _hoisted_8,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("sidebar_traffic_info.congestion")), 1)
      ])
    ])
  ]))
}